<template>
    <robotKms app="aff"
              appAuth="aicc-autofillform"
              :customColumn="customColumn"
              :answerInput="answerInput"
              @queryData="queryData"
              @setAnswerInput="setAnswerInput"
              @saveData="saveData"
              @updateData="updateData"
              @deleteData="deleteData"
    />
</template>

<script>
import robotKms from '@xiaoi/aicc-robot/views/ai/kms/kmsImport/index.vue'
import { selectFormTrigger, updateFormTrigger, addFormTrigger, deleteFormTrigger } from '@/api/autofillform/kms'
import { getFormList } from '@/api/autofillform/createAutofillform/autofillformList'

export default {
  name: 'index',
  components: {
    robotKms
  },
  data() {
    return {
      customColumn: [{
        id: 'affName',
        text: '表单名称'
      }],
      answerInput: {
        label: '工单',
        type: 'select',
        options: []
      }
    }
  },
  mounted() {
    getFormList({
      page: 1,
      limit: 999
    }).then(response => {
      this.answerInput.options = []
      const options = []
      response.data.data.root.forEach(function (form, index) {
        const option = {
          value: form.id,
          label: form.name
        }
        options.push(option)
      })
      this.answerInput.options = options
    }).catch(response => {
    })
  },
  methods: {
    queryData(data, resultFunction) {
      console.log(data)
      const resData = []
      const params = {
        faqIds: data
      }
      selectFormTrigger(params).then(response => {
        this.formTriggerList = response.data.data
        this.formTriggerList.forEach(function (formTrigger, index) {
          const affNames = []
          formTrigger.formList.forEach(function (form, index) {
            affNames.push(form.name)
          })
          const json = {
            faqId: formTrigger.faqId,
            affName: affNames.join(',')
          }
          resData.push(json)
        })
        resultFunction(resData)
      }).catch(response => {
      })
    },
    setAnswerInput(faqId, resultFunction) {
      const affIds = []
      const params = {
        faqIds: [faqId]
      }
      selectFormTrigger(params).then(response => {
        this.formTriggerList = response.data.data
        this.formTriggerList.forEach(function (formTrigger, index) {
          formTrigger.formList.forEach(function (form, index) {
            affIds.push(form.id)
          })
        })
        resultFunction(affIds)
      }).catch(response => {
      })
    },
    saveData(data, resultFunction) {
      const formTriggers = []
      data.data.forEach(function (formId, index) {
        formTriggers.push({ formId: formId, faqId: data.faqId })
      })
      addFormTrigger(formTriggers).then(response => {
        resultFunction()
      }).catch(response => {
      })
    },
    updateData(data, resultFunction) {
      const formTriggers = []
      data.data.forEach(function (formId, index) {
        formTriggers.push({ formId: formId, faqId: data.faqId })
      })
      updateFormTrigger(formTriggers).then(response => {
        resultFunction()
      }).catch(response => {
      })
    },
    deleteData(data) {
      const params = {
        faqIds: data
      }
      deleteFormTrigger(params).then(response => {
      }).catch(response => {
      })
    }
  }
}
</script>

<style scoped>

</style>
